import { useSupabaseQuery } from './useSupabaseQuery';

/**
 * View v_proprietarios — 1 linha por vínculo (imóvel × proprietário).
 * Campos: proprietario_id, imovel_id, imovel_nome, matricula, area_terreno_m2,
 * percentual_participacao, tipo_propriedade, empresa_id, company_name, contato_id,
 * first_name, last_name, contato_email, contato_mobile, tipo_pessoa (PJ|PF),
 * nome_display, area_id, area_nome.
 */
export function useProprietarios() {
  return useSupabaseQuery(
    (sb) => sb.from('v_proprietarios').select('*').order('nome_display'),
    []
  );
}
